import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const NotesIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M17.5 9.175L2.5 9.16667V10.8333H17.5V9.175ZM2.5 13.3333H12.5V15H2.5V13.3333ZM17.5 5H2.5V6.675L17.5 6.66667V5Z" />
  </Icon>
);

export default memo(NotesIcon);
